import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";

export default function canCreateProjects(viewer: ISelfieQuery["selfie"]) {
  if (!viewer) {
    return false;
  }

  if (viewer.__typename === "GovernmentUser") {
    return true;
  }

  if (viewer.__typename === "VendorUser") {
    return (viewer.company?.planUsage.projectsThisMonth || 0) < (viewer.company?.plan.limits.projectsPerMonth || 0);
  }

  return false;
}
